import { ValidationResultErrorMessage } from './validation-result-error-message.model';

export class ValidationResult {
    isValid: boolean;
    errorMessage?: ValidationResultErrorMessage;
    constructor() {
        this.isValid = true;
    }
}
